import {
  GET_ADMINSUBMISSION_REQUEST,
  GET_ADMINSUBMISSION_SUCCESS,
  GET_ADMINSUBMISSION_FAILURE,
  UPDATE_ADMINSUBMISSION_INPUT,
  GET_AFFILIATES_REQUEST,
  GET_AFFILIATES_SUCCESS,
  GET_AFFILIATES_FAILURE,
  GET_COUPONCODES_REQUEST,
  GET_COUPONCODES_SUCCESS,
  GET_COUPONCODES_FAILURE,
  GET_ADMININVOICES_REQUEST,
  GET_ADMININVOICES_SUCCESS,
  GET_ADMININVOICES_FAILURE,
  UPDATE_INVOICEPAID_ARRAY,
  DELETE_COUPON_FAILURE,
  DELETE_COUPON_SUCCESS,
  DELETE_COUPON_REQUEST
} from '../actions/Admin'
import * as c from '../constants/actionTypes';

let initialState = {
  loading: false,
  currentUser: '',
  userData: '',
  submissionForm: {},
  submissions: [],
  currentStatusFilter: null,
  totalSubmissions: 0,
  invoices: [],
  users: [],
  new_coupon_code: '',
  new_coupon_amount: 0,
  new_coupon_counter: 0,
  new_coupon_email: '',
  new_coupon_date: '',
  new_coupon_type: 'generic',
  affiliates: [],
  coupons: [],
  blog: [],
  invoices: [],
  invoicePaidSelect: []
}

export default (state = initialState, action) => {

  switch(action.type) {
    case UPDATE_INVOICEPAID_ARRAY:
      let tmpindx = state.invoices.indexOf(action.docid);
      if(state.invoices[tmpindx].is_paid){
          state.invoices[tmpindx].is_paid = 0;
      }else{
          state.invoices[tmpindx].is_paid = 1;
      }
      return state = Object.assign({}, state, {
        invoices: state.invoices
      })
    case GET_ADMINSUBMISSION_REQUEST:
      return state = Object.assign({}, state, {
        loading: action.loading
      })
    case GET_AFFILIATES_SUCCESS: {
      var newState = state;
      newState.affiliates = action.body.data;
      newState.loading = false;
      return Object.assign({}, state, newState);
    }
    case c.UPDATE_COUPON_PROP:
      var newState = state;
      console.log("updating coupon prop "+action.key+" with value "+action.value);
      newState[action.key] = action.value;
      return Object.assign({}, state, newState);
    case GET_ADMINSUBMISSION_SUCCESS:
    console.log("got response from API");
    console.log(action.body);
      return state = Object.assign({}, state, {
        loading: action.loading,
        submissions: action.body.data,
        currentStatusFilter: action.status,
        totalSubmissions: action.body.totalCount
      })
    case GET_ADMINSUBMISSION_FAILURE:
      return state = Object.assign({}, state, {
        loading: action.loading,
        error: action.error
      })
    case GET_ADMININVOICES_REQUEST:
      return state = Object.assign({}, state, {
        loading: action.loading
      })
    case GET_ADMININVOICES_SUCCESS:
      return state = Object.assign({}, state, {
        loading: action.loading,
        invoices: action.body.data
      })
    case GET_ADMININVOICES_FAILURE:
      return state = Object.assign({}, state, {
        loading: action.loading,
        error: action.error
      })
    case GET_COUPONCODES_REQUEST:
      return state = Object.assign({}, state, {
        loading: action.loading
      })
    case GET_COUPONCODES_SUCCESS:
      console.log("INSIDE ACTION COUPON CODES SUCCESS");
      console.log(action);
      console.log("INSIDE ACTION COUPON CODES SUCCESS");
      return state = Object.assign({}, state, {
        loading: action.loading,
        coupons: action.body.data
      })
    case GET_COUPONCODES_FAILURE:
      return state = Object.assign({}, state, {
        loading: action.loading,
        error: action.error
      })
    case UPDATE_ADMINSUBMISSION_INPUT:
      var submissionForm = state.submissionForm
      submissionForm[action.key] = action.value
      return state = Object.assign({}, state, {
        submissionForm: submissionForm
      })
    case DELETE_COUPON_REQUEST:
    case DELETE_COUPON_FAILURE:
    case DELETE_COUPON_SUCCESS:
      return state = Object.assign({}, state, {
        loading: action.loading,
      })
    default:
      return state

  }

}



// WEBPACK FOOTER //
// ./src/reducers/Admin.js